
import state from './quotationsState.js'
import * as mutations from './quotationsMutations.js'
import * as actions from './quotationsActions.js'
import * as getters from './quotationsGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}